import styled from 'styled-components';

import { fonts, Text } from '@dreryk/react-components';

type StyledDiagnosisProps = {
   $main: boolean;
};

export const StyledDiagnosis = styled.div<StyledDiagnosisProps>`
   display: grid;
   grid-template-columns: 50px 1fr;
   gap: 0px 5px;
   margin-bottom: 4px;

   font-weight: ${(props) => (props.$main ? fonts.fontWeightBold : fonts.fontWeightNormal)};
`;

StyledDiagnosis.displayName = 'StyledHistoricalVisitDiagnosisProps';

export const StyledDiagnosisContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
`;

StyledDiagnosisContent.displayName = 'StyledDiagnosisContent';

export const StyledDiagnosisAddidionalInformationText = styled(Text)`
   color: ${(props) => props.theme.borderDark};
`;

StyledDiagnosisAddidionalInformationText.displayName = 'StyledDiagnosisAddidionalInformationText';
